import { MigrationInterface, QueryRunner } from 'typeorm';
import { setMigrationRole } from './migration-role';

export class CamelCaseToSnakeCase1773650454102 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    await setMigrationRole(queryRunner);
    try {
      // Users table: rename columns to snake_case
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "bcCustomerId" TO "bc_customer_id"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "createdAt" TO "created_at"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "updatedAt" TO "updated_at"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "verifiedAt" TO "verified_at"
      `);

      // Update users index name to reflect new column casing
      await queryRunner.query(`
        DROP INDEX IF EXISTS "app"."IDX_users_bcCustomerId"
      `);
      await queryRunner.query(`
        CREATE INDEX "IDX_users_bc_customer_id" ON "app"."users" ("bc_customer_id")
      `);

      // Accounts table: rename columns to snake_case
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "userId" TO "user_id"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "providerAccountId" TO "provider_account_id"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "createdAt" TO "created_at"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "updatedAt" TO "updated_at"
      `);

      // Update accounts index and constraint names to match new column names
      await queryRunner.query(`
        DROP INDEX IF EXISTS "app"."IDX_accounts_userId"
      `);
      await queryRunner.query(`
        CREATE INDEX "IDX_accounts_user_id" ON "app"."accounts" ("user_id")
      `);

      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME CONSTRAINT "UQ_accounts_provider_providerAccountId" TO "UQ_accounts_provider_provider_account_id"
      `);

      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME CONSTRAINT "FK_accounts_userId" TO "FK_accounts_user_id"
      `);
    } finally {
      await queryRunner.query('RESET ROLE');
    }
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    await setMigrationRole(queryRunner);
    try {
      // Revert constraint and index names on accounts
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME CONSTRAINT "FK_accounts_user_id" TO "FK_accounts_userId"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME CONSTRAINT "UQ_accounts_provider_provider_account_id" TO "UQ_accounts_provider_providerAccountId"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
          RENAME COLUMN "user_id" TO "userId"
      `);
      await queryRunner.query(`
        DROP INDEX IF EXISTS "app"."IDX_accounts_user_id"
      `);
      await queryRunner.query(`
        CREATE INDEX "IDX_accounts_userId" ON "app"."accounts" ("userId")
      `);

      // Revert accounts column names
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "updated_at" TO "updatedAt"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "created_at" TO "createdAt"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."accounts"
        RENAME COLUMN "provider_account_id" TO "providerAccountId"
      `);
      // Revert users index
      await queryRunner.query(`
        ALTER TABLE "app"."users"
          RENAME COLUMN "bc_customer_id" TO "bcCustomerId"
      `);
      await queryRunner.query(`
        DROP INDEX IF EXISTS "app"."IDX_users_bc_customer_id"
      `);
      await queryRunner.query(`
        CREATE INDEX "IDX_users_bcCustomerId" ON "app"."users" ("bcCustomerId")
      `);

      // Revert users column names
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "verified_at" TO "verifiedAt"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "updated_at" TO "updatedAt"
      `);
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        RENAME COLUMN "created_at" TO "createdAt"
      `);
    } finally {
      await queryRunner.query('RESET ROLE');
    }
  }
}
